import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "code",
  "use": "code-usage",
  "viewBox": "0 0 20 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 18\" id=\"code\"><path d=\"M12.009.035l1.437.43-5.227 17.5-1.438-.43zm1.437.43l-5.227 17.5-1.438-.43L12.01.035zM2.012 9.065l4.541 4.96-1.106 1.013-5.46-5.963 5.455-6.076 1.116 1.002zM13.493 14.025l1.106 1.013 5.46-5.963-5.455-6.076-1.116 1.002 4.545 5.064z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id